/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */
// baki
import React, { useState, useContext, useEffect } from 'react';
import Alert from 'react-s-alert';
import moment from 'moment';
import { Button, FormGroup, InputGroup, InputGroupAddon, Label, Input, Table } from 'reactstrap';
import Joyride, { STATUS } from 'react-joyride';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// service imports
import AuthService from '../../services/AuthService';
import ClientService from '../../services/ClientService';
import ProviderService from '../../services/ProviderService';
import GeneralService from '../../services/GeneralService';

// local imports
import UserNotApproved from './UserNotApproved';
import ErrorBoundary from '../general/ErrorBoundary';
import Loading from '../../assets/UW_Horizontal_Logo_Full.png';
import ProviderNavbar from './ProviderNavbar';
import SelectedClient from './SelectedClient';

const ConfirmSession = props => {

    // contexts
    const { theme } = useContext(ThemeContext);
    const { user, setUser, userApprovalStatus } = useContext(AuthContext);

    // states
    const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [voucherData, setVoucherData] = useState();
    const [voucher, setVoucher] = useState('');
    const [extraVoucher, setExtraVoucher] = useState(0);
    const [couponData, setCouponData] = useState();
    const [coupon, setCoupon] = useState('');
    const [totalAmount, setTotalAmount] = useState(0);
    const [GST, setGST] = useState({ percent: 0, amount: 0 });
    const [couponAmount, setCouponAmount] = useState(0);
    const [voucherAmount, setVoucherAmount] = useState(0);
    const [selectedClient, setSelectedClient] = useState();
    const [providerDetail, setProviderDetail] = useState({ availableTimings: [], modeOfService: { call: {}, chat: {}, video: {}, inPerson: {} }, reportCharge: 0, GSTCharge: 0 });
    const [sessionDetails, setSessionDetails] = useState({
        selectedDate: "",
        selectedTimeSlot: [],
        modeOfServiceSelected: {},
        isReportIncluded: {}
    });
    const [paymentDetails, setPaymentDetails] = useState({});
    const [isFirstSession, setIsFirstSession] = useState(false);
    const [tutorial, setTutorial] = useState({
        status: false,
        steps: [
            {
                content: <div><h2>You can make payments using this page.</h2><br />Confirm your choice of session details and optionally apply Coupon Code or Gift Voucher Code, if any.</div>,
                placement: 'center',
                target: '#makePaymentDiv',
            },
            {
                content: <div className="tooltipDiv">Confirm your session details before proceeding.</div>,
                placement: 'bottom',
                target: '#sessionDetails'
            },
            {
                content: <div className="tooltipDiv">If you have a GiftVoucher from Umang Wellness you can apply it here.<br />You can always buy and gift it to someone from our <a href="/">Home page</a>.</div>,
                placement: 'right',
                target: '#giftVoucher'
            },
            {
                content: <div className="tooltipDiv">If you have a Coupon code from Umang Wellness you can apply it here</div>,
                placement: 'right',
                target: '#coupon'
            },
            {
                content: <div className="tooltipDiv">Here you will see the final summary of the payment</div>,
                placement: 'top',
                target: '#finalCharges'
            },
            {
                content: <div className="tooltipDiv">Press here to proceed to our payment gateway.<br />You may use UPI, Debit card, Creding card and Netbanking to pay the amount.<br />Payments are secured and powered by Razorpay</div>,
                placement: 'top',
                target: '#bookBtn'
            }
        ]
    });
    let helpers = null;

    // useEffect
    useEffect(() => {
        // if (!user.guideTakenFor.includes("MakePayment")) {
        //     setTutorial({ ...tutorial, status: true });
        // }
    }, []);

    useEffect(() => {
        try {
            if (props.location.state) {
                // console.log("state", props.location.state);
                const GSTPercentage = props.location.state.providerDetail.GSTCharge;
                let total = Number(props.location.state.modeOfServiceSelected.rate * props.location.state.selectedTimeSlot.length) + Number(props.location.state.isReportIncluded.amount);
                let GST = (total * GSTPercentage) / 100;
                // let totalWithGST = total + GST;
                setSelectedClient(props.location.state.selectedClient);
                setSessionDetails(props.location.state);
                setIsFirstSession(props.location.state.isFirstSession);
                if (props.location.state.isFirstSession) {
                    setGST({ percent: 0, amount: 0 });
                    setTotalAmount(0);
                } else {
                    setGST({ percent: GSTPercentage, amount: GST });
                    setTotalAmount(total);
                }
            } else {
                props.history.replace('/reservesession');
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Client MakePayment useEffect2', 'Error in try catch block', err.stack);
        }
    }, [props.location.state]);

    // utility functions
    // handle functions
    const applyCoupon = () => {
        try {
            if (voucherAmount > 0) {
                Alert.error("You cannot apply Voucher and Coupon at same time", {
                    position: 'top-right',
                    effect: 'slide'
                });
            } else {
                ClientService.applyCoupon(coupon)
                    .then(data => {
                        if (data.data.type === "percentage") {
                            const couponAmount = totalAmount * (data.data.value / 100);
                            if (couponAmount > data.data.maxDiscount) {
                                setCouponData(data.data);
                                setCouponAmount(data.data.maxDiscount);
                                setGST({ ...GST, amount: (totalAmount - data.data.maxDiscount) * (GST.percent / 100) })
                            }
                            else {
                                setCouponData(data.data);
                                setCouponAmount(couponAmount);
                                setGST({ ...GST, amount: (totalAmount - couponAmount) * (GST.percent / 100) })
                            }
                        } else {
                            if (totalAmount < data.data.minPurchaseRequired) {
                                Alert.error(`Coupon applicable only on amount above ${data.data.minPurchaseRequired}`, {
                                    position: 'top-right',
                                    effect: 'slide'
                                });
                                return;
                            } else {
                                setCouponData(data.data);
                                setCouponAmount(data.data.value);
                                setGST({ ...GST, amount: (totalAmount - data.data.value) * (GST.percent / 100) });
                            }
                        }
                        Alert.info(data.message.msgBody, {
                            position: 'top-right',
                            effect: 'slide'
                        });
                    })
                    .catch(error => {
                        Alert.error(error.message.msgBody, {
                            position: 'top-right',
                            effect: 'slide'
                        });
                    });
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Client MakePayment applyCoupon', 'Error in try catch block', err.stack);
        }
    }

    const removeCoupon = () => {
        try {
            setCoupon();
            setCouponData();
            setCouponAmount(0);
            setGST({ ...GST, amount: (totalAmount - 0) * (GST.percent / 100) });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Client MakePayment removeCoupon', 'Error in try catch block', err.stack);
        }
    }

    const applyVoucher = () => {
        try {
            if (couponAmount > 0) {
                Alert.error("You cannot apply Coupon and Voucher at same time", {
                    position: 'top-right',
                    effect: 'slide'
                });
            } else {
                ClientService.applyVoucher(voucher)
                    .then(data => {
                        setVoucherData(data.data);
                        if (totalAmount < data.data.amount) {
                            setExtraVoucher(data.data.amount - totalAmount);
                            setVoucherAmount(totalAmount);
                        } else {
                            setVoucherAmount(data.data.amount);
                        }
                        Alert.info(data.message.msgBody, {
                            position: 'top-right',
                            effect: 'slide'
                        });
                    })
                    .catch(error => {
                        Alert.error(error.message.msgBody, {
                            position: 'top-right',
                            effect: 'slide'
                        });
                    });
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Client MakePayment applyVoucher', 'Error in try catch block', err.stack);
        }
    }

    const removeVoucher = () => {
        try {
            setVoucher();
            setVoucherData();
            setExtraVoucher(0)
            setVoucherAmount(0);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Client MakePayment removeVoucher', 'Error in try catch block', err.stack);
        }
    }

    const sendPaymentLink = async (sessionId) => {
        try {
            let body = {
                amount: totalAmount - couponAmount - voucherAmount + GST.amount,
                currency: "INR",
                description: "",
                customerName: `${selectedClient.clientId.title} ${selectedClient.clientId.firstName} ${selectedClient.clientId.lastName}`.trim(),
                customerPhone: `+${selectedClient.clientId.phone}`,
                customerEmail: selectedClient.clientId.email,
                notifyEmail: true,
                notifySMS: false,
                notes: {
                    paymentAgainst: "Session booking",
                    sessionId,
                    linkCreatedBy: user.email,
                }
            };
            if (couponData) {
                body.notes.coupon = couponData.id;
            }
            if (voucherData) {
                body.notes.voucher = voucherData.id;
            }
            ProviderService.createPaymentLink(body)
                .then(data => {
                    Alert.info(data.message, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    removeCoupon();
                    removeVoucher();
                    setUser({ ...user, bookSessionDetails: null });
                    setIsLoading(false);
                    props.history.push("/counsellor/sessions");
                })
                .catch(error => { console.log("error1", error); setIsLoading(false); })
            // }
        } catch (err) {
            // console.log("error2", err);
            setIsLoading(false);
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Client MakePayment displayRazorpay', 'Error in try catch block', err.stack);
        }
    }

    const bookSession = () => {
        try {
            setIsLoading(true);
            let paymentDetail = {};
            if (isFirstSession) {
                paymentDetail = "Free Session";
            } else if ((totalAmount - couponAmount - voucherAmount + GST.amount) === 0) {
                paymentDetail = { voucher: voucherData, coupon: couponData, amount: '0.00' };
            } else {
                // let paymentDetail = data.paymentLinkDetails;
                let coupon = couponData;
                let voucher = voucherData;
                if (coupon) {
                    coupon.value = couponAmount;
                }
                if (voucher) {
                    voucher.value = voucherAmount;
                }
                paymentDetail.coupon = coupon;
                paymentDetail.voucher = voucher;
            }
            ProviderService.bookSession(sessionDetails, paymentDetail, extraVoucher)
                .then(data => {
                    // console.log("data", data);
                    sendPaymentLink(data.sessionId);
                    // Alert.info(data.message, {
                    //     position: 'top-right',
                    //     effect: 'slide'
                    // });
                    // removeCoupon();
                    // removeVoucher();
                    // setUser({ ...user, bookSessionDetails: null });
                    // setIsLoading(false);
                    // props.history.push("/counsellor/sessions");
                })
                .catch(error => {
                    setIsLoading(false);
                    Alert.error(error.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                });
        } catch (err) {
            setIsLoading(false);
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider ConfirmSession bookSession', 'Error in try catch block', err.stack);
        }
    }

    const handleJoyrideCallback = (data) => {
        const { status, type } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            if (!user.guideTakenFor.includes("MakePayment")) {
                AuthService.markVisited("MakePayment");
                setUser({ ...user, guideTakenFor: [...user.guideTakenFor, "MakePayment"] });
            }
            setTutorial({ ...tutorial, status: false });
        }
    };

    const getHelpers = (paramHelpers) => {
        helpers = paramHelpers;
    };

    // function's return
    return (
        <div id="makePaymentDiv">
            {/*<ErrorBoundary errorAt="At Client MakePayment Joyride">
                <Joyride
                    callback={handleJoyrideCallback}
                    continuous={true}
                    getHelpers={getHelpers}
                    run={tutorial.status}
                    scrollToFirstStep={true}
                    showProgress={true}
                    showSkipButton={true}
                    steps={tutorial.steps}
                    locale={{ last: 'Finish' }}
                    styles={{
                        options: {
                            primaryColor: "rgb(56, 78, 115)",
                            zIndex: 10000,
                        },
                    }}
                />
                </ErrorBoundary>*/}
            <ErrorBoundary errorAt="At Client MakePayment ClientNavbar">
                <ProviderNavbar history={props.history} showTutorial={() => setTutorial({ ...tutorial, status: true })} />
            </ErrorBoundary>
            {
                isLoading ?
                    <img className="mx-auto d-block" height="auto" width="40%" src={Loading} alt="Loading..." />
                    :
                    userApprovalStatus ?
                        <div className="p-3">

                            {/* Page Heading */}
                            <div>
                                <h1 style={theme.headingBold}>Confirm Session</h1>
                                <hr style={{ borderWidth: "2px" }} />
                            </div>

                            {/* Confirm Session Details */}
                            <div className="p-3">
                                <h2 style={theme.subHeadingSemibold}>Confirm Session Details</h2>
                                <hr />

                                <ErrorBoundary errorAt="At Client MakePayment SelectedProvider">
                                    <SelectedClient client={selectedClient} />
                                </ErrorBoundary>

                                <ErrorBoundary errorAt="At Client MakePayment Table">
                                    <Table borderless className="mt-4" id="sessionDetails">
                                        <tbody>
                                            <tr>
                                                <td style={{ minWidth: '10rem', width: '10rem' }}>
                                                    <span style={theme.paragraphMDSM}>Session Date</span>
                                                </td>
                                                <td>
                                                    <span style={theme.paragraphMDSM}>{moment(sessionDetails.selectedDate).format('MMM DD, dddd')}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={theme.h3HeadingSemibold}>Session Time</span>
                                                </td>
                                                <td>
                                                    <span style={theme.paragraphMDSM}>{sessionDetails.selectedTimeSlot.map(item => `${moment(item.from).utcOffset("+05:30").format("hh:mm A")} - ${moment(item.to).utcOffset("+05:30").format("hh:mm A")}`).join(", ")}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={theme.h3HeadingSemibold}>Mode of Service</span>
                                                </td>
                                                <td>
                                                    <span style={theme.paragraphMDSM}>{sessionDetails.modeOfServiceSelected.name}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </ErrorBoundary>
                            </div >

                            {/* Payment */}
                            <div className="p-3" >
                                <h2 style={theme.subHeadingSemibold}>Payment Details</h2>
                                <hr />
                                {
                                    isFirstSession ? null :
                                        voucherData ?
                                            <div>
                                                <InputGroup style={{ maxWidth: "20rem" }}>
                                                    <Input disabled className="form-control" style={theme.formInput} value={voucher} />
                                                    <InputGroupAddon addonType="append" className="ml-3">
                                                        <Button type="button" style={theme.formButtonDanger} onClick={removeVoucher}>Remove</Button>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                                <p className="my-1">
                                                    <i className="fas fa-check-circle" style={{ color: "#384E73" }}></i> Gift voucher applied worth ₹{voucherAmount}
                                                </p>
                                                {
                                                    extraVoucher > 0 ?
                                                        <p className="my-1">
                                                            <i className="fas fa-check-circle" style={{ color: "#384E73" }}></i> Remaining balance of ₹{extraVoucher} will be sent back as a gift voucher to your email
                                                        </p> : null
                                                }
                                            </div>
                                            :
                                            <FormGroup style={{ maxWidth: "20rem" }} id="giftVoucher">
                                                <Label for="code" style={theme.formBodyText} >Have a gift voucher?</Label>
                                                <InputGroup>
                                                    <Input type="text" name="code" value={voucher} onChange={(e) => setVoucher(e.target.value)} className="form-control" style={theme.formInput} />
                                                    <InputGroupAddon addonType="append" className="ml-3">
                                                        <Button type="button" style={theme.formButton} onClick={applyVoucher}>Apply</Button>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            </FormGroup>
                                }
                                {isFirstSession ? null : <div style={{ marginLeft: '7rem' }}>OR</div>}
                                {
                                    isFirstSession ? null :
                                        couponData ?
                                            <div>
                                                <InputGroup className="mt-2" style={{ maxWidth: "20rem" }}>
                                                    <Input disabled className="form-control" style={theme.formInput} value={coupon} />
                                                    <InputGroupAddon addonType="append" className="ml-3">
                                                        <Button type="button" style={theme.formButtonDanger} onClick={removeCoupon}>Remove</Button>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                                <p className="my-1">
                                                    <i className="fas fa-check-circle" style={{ color: "#384E73" }}></i> {couponData.description}
                                                </p>
                                            </div>
                                            :
                                            <FormGroup className="mt-2" style={{ maxWidth: "20rem" }} id="coupon">
                                                <Label for="code" style={theme.formBodyText} >Have coupon code?</Label>
                                                <InputGroup>
                                                    <Input type="text" name="code" value={coupon} onChange={(e) => setCoupon(e.target.value)} className="form-control" style={theme.formInput} />
                                                    <InputGroupAddon addonType="append" className="ml-3">
                                                        <Button type="button" style={theme.formButton} onClick={applyCoupon}>Apply</Button>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            </FormGroup>
                                }
                                <ErrorBoundary errorAt="At Client MakePayment Table">
                                    <Table borderless className="mt-4" id="finalCharges">
                                        <tbody>
                                            <tr>
                                                <td style={{ minWidth: '12.5rem', width: '12.5rem' }}>
                                                    <span style={theme.h3HeadingSemibold}>Session Charges</span>
                                                </td>
                                                <td>
                                                    <span style={theme.paragraphMDSM}>₹
                                                        {
                                                            isFirstSession
                                                                ? 0
                                                                : sessionDetails.modeOfServiceSelected.rate * sessionDetails.selectedTimeSlot.length
                                                        }
                                                    </span>
                                                </td>
                                            </tr>
                                            {
                                                sessionDetails.isReportIncluded.status && !isFirstSession ?
                                                    <tr>
                                                        <td>
                                                            <span style={theme.h3HeadingSemibold}>Report Charges</span>
                                                        </td>
                                                        <td>
                                                            <span style={theme.paragraphMDSM}>₹{sessionDetails.isReportIncluded.amount}</span>
                                                        </td>
                                                    </tr>
                                                    : null
                                            }
                                            {
                                                voucherAmount > 0 ?
                                                    <tr>
                                                        <td>
                                                            <span style={theme.h3HeadingSemibold}>Gift Voucher applied</span>
                                                        </td>
                                                        <td>
                                                            <span style={theme.paragraphMDSM}>₹{voucherAmount}</span>
                                                        </td>
                                                    </tr> : null
                                            }
                                            {
                                                couponAmount > 0 ?
                                                    <tr>
                                                        <td>
                                                            <span style={theme.h3HeadingSemibold}>Coupon Code applied</span>
                                                        </td>
                                                        <td>
                                                            <span style={theme.paragraphMDSM}>₹{couponAmount}</span>
                                                        </td>
                                                    </tr> : null
                                            }
                                            <tr>
                                                <td>
                                                    <span style={theme.h3HeadingSemibold}>GST({GST.percent}%)</span>
                                                </td>
                                                <td>
                                                    <span style={theme.paragraphMDSM}>₹{GST.amount}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={theme.h3HeadingSemibold}>Total Amount Due</span>
                                                </td>
                                                <td>
                                                    <span style={theme.paragraphMDSM}>₹{totalAmount - couponAmount - voucherAmount + GST.amount}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </ErrorBoundary>
                            </div>

                            <ErrorBoundary errorAt="At Client MakePayment BookBtn">
                                <button className="btn my-2" style={theme.button} onClick={() => bookSession()} id="bookBtn">
                                    {isFirstSession ? 'Reserve for FREE' : 'Reserve Now'}
                                </button>
                            </ErrorBoundary>
                            <br />
                            <text>*Payment link will be sent to client once you reserve the session</text>
                            <text>*Payments are powered by Razorpay</text>
                        </div>
                        :
                        <UserNotApproved />
            }
        </div >
    )
}
export default ConfirmSession;